<template>
   
    <!-- <nav role="navigation"> -->
 
        <ul class="breadcrumbs"  v-if="bcloaded"> 
            <li  v-for="(row,i) in breadbar" :key=i >
                <RouterLink  :to="row.url" v-html="row.desc"></RouterLink>
               <!-- <span  @click="compNofromEventNo(row.url,row.eventno,row.compdesc)" :key="i" v-html="row.desc" ></span> -->
            </li>

        </ul>
    <!-- </nav> -->
</template>

<script>

import axios from 'axios';

    export default {
        name: "breadcrumb",
        data: function () {
            return {
                breadbar: [],
                bcloaded: false,
                selectedcomps: ''
            }    
        },

        async serverPrefetch() {
            await this.breadData();
        },

        async mounted() {
            if (!this.$store.state.wasSSR)
            await this.breadData();
        },
        methods: {

            clickGo: function(navigate) {
             
             //   this.$store.commit('setEventParams',this.selectedcomps);
this.$nextTick(() => {
                navigate()
});
            },

            async breadData() {

                //get the routes of the URL
                let URL = this.$route.fullPath;
                var compParts = URL.split("/").filter(Boolean).slice(1, 4);
             
             

                //how many crumbs are there and what is the base URL
                var noComponents = compParts.length;//3 because (i) zero based array and because dont want current event
                var href = process.env.VUE_APP_WEBSITE;

                //create variables for creating array of objects that provide info for breadcrumb
                var breadbarItem = { url: '', desc: '', compdesc: ''};
                var breadbarItems = new Array();
                var i = 0;
           

                //create array
                for (i; i < noComponents; i++) {

                    breadbarItem.url = href;

                    switch (i) {
                        case 0:
                            //sport
                            breadbarItem.url = '/Sport/' + compParts[0] + "/All";

                            var sportsimg = "/assets/images/sports/svg/" + compParts[0]+ ".svg";

                            breadbarItem.desc = "<span><img class='show-for-medium' src='" + sportsimg  + "' style='width:14px;height:14px;margin-right:4px'//>" + compParts[i] + "</span>";

                            // breadbarItem.desc = "<div class='" + compParts[i] + "24' style='display:inline-flex;align-items: center'><span style='padding-left:30px'></div><div style='display:inline-flex;align-items: center;padding-left:5px'>" + compParts[i] + "</div>";
                            
                            break;
                        case 1:
                            // sport and country
                            breadbarItem.url = '/Sport/' + compParts[0] + '/' + compParts[1];

                            var countryimg = "/assets/images/flags/svg/" + compParts[1]+ ".svg";
                            
                            breadbarItem.desc = "<span><img class='show-for-medium flagsmall' src='" + countryimg  + "' style='width:14px;height:14px;margin-right:4px'>" + compParts[1] + "</span>";
                            break;
                        case 2:

                 
                            // country and league 
                            breadbarItem.url = '/Competition/' + compParts[0] + '/' + String(compParts[2]);
                            //compParts[i] = compParts[i].replace(/-/g, '-');
                            breadbarItem.desc = "<span>" + compParts[2].replace(/-/g, ' ') + "</span>";
                            //breadbarItem.eventno = this.$store.state.bid;
                            breadbarItem.compdesc = String(compParts[i] || '').replace(/-/g, '/')
                                          
                            break;
                        default:
                            
                            }       


                   

                    breadbarItems.push(JSON.parse(JSON.stringify(breadbarItem)));
                }


                //set array to vm data property and set flag to update
                this.breadbar = breadbarItems;



                this.bcloaded = true;
            
            },
            
            compNofromEventNo: function (URLPre, eventNo, compDesc)
            {

                if (eventNo == '' || eventNo == 0) {
               
                
                    this.$router.push(URLPre);
                } else {



                    axios.get(process.env.VUE_APP_WEBAPI  + "FeatureTables.svc/CompNofromEventNo", {

                        params: {
                            eventno:eventNo
                        }

                    }).then(response => {

                        var compNo = JSON.parse(response.data);

                        let compNoArray = [];
                        compNoArray.push(compDesc+'-'+ compNo + '-1-1');
                        
                

                        this.$store.commit('setEventParams', compNoArray);

                        var URL = URLPre + compDesc;

                        this.$nextTick(() => {
                            
                            this.$router.push(URL);
                        });
                       


                    });
                }
            }
        }
            
    };

    

</script>


<style>

.breadcrumbs li{
    
    cursor: pointer;

}

.breadcrumbs a {
    color: black;
}
</style>